import { render, staticRenderFns } from "./MessageDetailModal.vue?vue&type=template&id=40313ccd"
import script from "./MessageDetailModal.vue?vue&type=script&lang=js"
export * from "./MessageDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports